"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModernMobileView = void 0;
const React = require("react");
const teamsIllustrationImg = require("../../images/v2/welcome_to_teams.svg");
const tflIllustrationImg = require("../../images/v2/welcome_to_tfl.svg");
const JoinLauncherContext_1 = require("../../contexts/join-launcher/JoinLauncherContext");
const TelemetryEvents_1 = require("../../models/telemetry/TelemetryEvents");
const Logger_1 = require("../../services/Logger");
const TranslationService_1 = require("../../services/TranslationService");
const AppStoreButton_1 = require("../common/AppStoreButton");
const Button_1 = require("../common/Button");
const Footer_1 = require("../common/Footer");
const Spacer_1 = require("../common/Spacer");
const Translate_1 = require("../common/Translate");
const View_1 = require("../common/View");
require("./modernMobileView.scss");
const Environment_1 = require("../../models/Environment");
const EnvironmentService_1 = require("../../services/EnvironmentService");
class ModernMobileView extends React.Component {
    constructor(props) {
        super(props);
        this.finalPanelViewReported = false;
        this.state = {
            isCopyToClipboardChecked: !!props.isTflLink,
        };
    }
    render() {
        const { browserJoin } = this.props;
        let illustration;
        let headerFirst;
        let headerSecond;
        let downloadButtonTitle;
        let joinButtonTitle;
        let joinButtonStyle;
        let meetingLinkCopyDescription;
        let downloadButtonDescription;
        let joinButtonDescription;
        let isCopyLinkToClipboardAllowed = false;
        let shouldRenderCopyLinkToClipboardCheckbox = false;
        if (!this.props.isTflLink) {
            illustration = teamsIllustrationImg;
            headerFirst = "hdr_mobile_first";
            headerSecond = "hdr_mobile_second";
            downloadButtonTitle = "btn_mobile_download";
            joinButtonDescription = this.renderMessage("txt_mobile_secondary_button_description");
            joinButtonTitle = "btn_mobile_join_meeting";
            joinButtonStyle = (browserJoin === null || browserJoin === void 0 ? void 0 : browserJoin.enabled) ? "primary mobile" : "secondary mobile";
            meetingLinkCopyDescription = "mobile_copy_clipboard_description";
            isCopyLinkToClipboardAllowed = EnvironmentService_1.default.getOS() === Environment_1.OperatingSystems.iOS;
        }
        else {
            illustration = tflIllustrationImg;
            headerFirst = "hdr_mobile_first_conversation";
            headerSecond = "hdr_mobile_second_join_conversation_ios";
            downloadButtonDescription = this.renderMessage("txt_mobile_join_conversation_step1", true);
            downloadButtonTitle = "hdr_mobile_acquire_app";
            joinButtonDescription = this.renderMessage("txt_mobile_join_conversation_step2");
            joinButtonTitle = "btn_mobile_join_conversation";
            joinButtonStyle = "primary mobile";
            shouldRenderCopyLinkToClipboardCheckbox = EnvironmentService_1.default.getOS() === Environment_1.OperatingSystems.iOS;
        }
        return (React.createElement(JoinLauncherContext_1.JoinLauncherContextConsumer, null, ({ joinInfo }) => {
            this.reportSuccessPanelView("mobile_join_launcher_loaded", joinInfo);
            return (React.createElement(View_1.View, { className: "modernMobileView" },
                React.createElement("div", { className: "body column centered" },
                    React.createElement("h1", null,
                        React.createElement(Translate_1.Translate, { i18n: headerFirst })),
                    React.createElement("img", { className: "illustration", src: illustration }),
                    !(browserJoin === null || browserJoin === void 0 ? void 0 : browserJoin.enabled) && (React.createElement("div", { className: "message" },
                        React.createElement(Translate_1.Translate, { i18n: headerSecond }))),
                    !(browserJoin === null || browserJoin === void 0 ? void 0 : browserJoin.enabled) && downloadButtonDescription,
                    shouldRenderCopyLinkToClipboardCheckbox &&
                        this.renderCopyClipboardCheckBox("mobile_copy_link_checkbox_label", joinInfo),
                    !this.props.featureFlags.hideDownloadButton && !(browserJoin === null || browserJoin === void 0 ? void 0 : browserJoin.enabled) && (React.createElement(AppStoreButton_1.AppStoreButton, { newUI: true, onClickCallback: () => {
                            this.reportPanelAction(TelemetryEvents_1.ModuleNames.Download, joinInfo);
                        }, title: TranslationService_1.default.translate(downloadButtonTitle), shouldCopyLinkToClipboard: isCopyLinkToClipboardAllowed ||
                            (shouldRenderCopyLinkToClipboardCheckbox &&
                                this.state.isCopyToClipboardChecked) })),
                    !(browserJoin === null || browserJoin === void 0 ? void 0 : browserJoin.enabled) && joinButtonDescription,
                    React.createElement(Button_1.Button, { className: joinButtonStyle, "data-tid": "joinInApp", onClick: () => {
                            this.reportPanelAction(TelemetryEvents_1.ModuleNames.JoinInApp, joinInfo);
                            this.props.onLaunchClick();
                        } },
                        React.createElement(Translate_1.Translate, { i18n: (browserJoin === null || browserJoin === void 0 ? void 0 : browserJoin.enabled) ? "btn_mobile_tfl_join_teams" : joinButtonTitle })),
                    (browserJoin === null || browserJoin === void 0 ? void 0 : browserJoin.enabled) && (React.createElement(Button_1.Button, { className: "secondary mobile", "data-tid": "joinOnWeb", onClick: browserJoin.onClick },
                        React.createElement(Translate_1.Translate, { i18n: "hdr_btn_join_in_this_browser" }))),
                    React.createElement(Spacer_1.Spacer, null),
                    !(browserJoin === null || browserJoin === void 0 ? void 0 : browserJoin.enabled) &&
                        isCopyLinkToClipboardAllowed &&
                        this.renderMessage(meetingLinkCopyDescription),
                    React.createElement(Spacer_1.Spacer, null)),
                React.createElement(Footer_1.Footer, { onLinkClick: () => this.reportPanelAction(TelemetryEvents_1.ModuleNames.ShowThirdPartyNotice, joinInfo) })));
        }));
    }
    renderMessage(message, spacer) {
        return (React.createElement(React.Fragment, null,
            spacer ? React.createElement(Spacer_1.Spacer, null) : null,
            React.createElement("div", { className: "message" },
                React.createElement(Translate_1.Translate, { i18n: message }))));
    }
    renderCopyClipboardCheckBox(label, joinInfo) {
        return (React.createElement("div", { className: "checkboxContainer" },
            React.createElement("input", { type: "checkbox", className: "checkbox", checked: this.state.isCopyToClipboardChecked, onClick: () => {
                    this.reportPanelAction(TelemetryEvents_1.ModuleNames.CopyLinkToClipboard, joinInfo);
                    this.setState({
                        isCopyToClipboardChecked: !this.state.isCopyToClipboardChecked,
                    });
                } }),
            " ",
            TranslationService_1.default.translate(label)));
    }
    reportSuccessPanelView(name, joinInfo, props) {
        if (!this.finalPanelViewReported) {
            const panelViewEvent = new TelemetryEvents_1.PanelViewEvent(name, joinInfo, Object.assign(Object.assign({}, props), { launchResult: this.props.launchResult }));
            Logger_1.default.logUserBiPanelView(panelViewEvent);
            this.finalPanelViewReported = true;
        }
    }
    reportPanelAction(moduleName, joinInfo) {
        const panelActionEvent = new TelemetryEvents_1.PanelActionEvent(TelemetryEvents_1.PanelActionScenarioNames.ModernMobileView, moduleName, joinInfo);
        Logger_1.default.logUserBiPanelAction(panelActionEvent);
    }
}
exports.ModernMobileView = ModernMobileView;
